
export default class CookieBanner
{
    constructor(wrapper) {
        this.wrapper = $(wrapper);

        this.bind_elements();
        this.bind_events();
    }

    bind_elements() {
        this.banner = this.wrapper.find('#bcc-banner');
        this.accept_action = this.wrapper.find('#accept-action');
        this.reject_action = this.wrapper.find('#reject-action');
        this.triggers = $('a[href$="#manage-cookies"]');
    }

    bind_events() {
        this.accept_action.click(() => this.accept_cookies());
        this.reject_action.click(() => this.reject_cookies());
        this.triggers.click((event) => this.open_banner(event));
    }

    accept_cookies() {
        this.set_cookie(true);
        this.close_banner();
    }

    reject_cookies() {
        this.set_cookie(false);
        this.close_banner();
    }

    set_cookie(value) {
        set_cookie('bcc_cookies_accepted', value);
    }

    open_banner(event) {
        event.preventDefault();
        this.banner.removeClass('is-closed');
    }

    close_banner() {
        this.banner.addClass('is-closed');
    }
}
